import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/auth-2.jpg")